import { render, staticRenderFns } from "./BtnRow.vue?vue&type=template&id=c9ab10c2&scoped=true&"
import script from "./BtnRow.vue?vue&type=script&lang=js&"
export * from "./BtnRow.vue?vue&type=script&lang=js&"
import style0 from "./BtnRow.vue?vue&type=style&index=0&id=c9ab10c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ab10c2",
  null
  
)

export default component.exports